export default {

    init() {
        const links = document.querySelectorAll("[data-hyperlink]");

        if (links.length) {
            for (const link of links) {
                link.addEventListener('click', () => {
                    const target = link.getAttribute("data-link-target");
                    if(target != null){
                        window.location = link.getAttribute("data-hyperlink");
                    }else{
                        window.open(link.getAttribute("data-hyperlink"),'_blank');
                    }
                })
            }
        }     
    }
}